import { useEffect, useState } from "react";
import { Clock } from "lucide-react";

const TIME_ZONE = "Asia/Jakarta";

const dateFormat = new Intl.DateTimeFormat("id-ID", {
  timeZone: TIME_ZONE,
  weekday: "long",
  day: "2-digit",
  month: "long",
  year: "numeric",
});

const timeFormat = new Intl.DateTimeFormat("en-GB", {
  timeZone: TIME_ZONE,
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: false,
});

export default function LiveClock({ className = "" }) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <span
      className={`inline-flex max-w-full items-center gap-1.5 sm:gap-2 rounded-full border border-slate-200 bg-slate-50 px-2.5 sm:px-3 py-1 font-mono text-[10px] sm:text-xs tabular-nums text-slate-600 min-[360px]:whitespace-nowrap ${className}`}
      data-testid="live-clock"
      aria-live="off"
    >
      <Clock size={13} className="shrink-0 text-[#00B9AD]" />
      <span>{dateFormat.format(now)} - {timeFormat.format(now)} WIB</span>
    </span>
  );
}
